import { styled } from '@mui/material/styles';
import Paper from '../../../../../../shared/library/Paper';

export const StyledWrapper = styled(Paper)({
  position: 'relative',
});

export const StyledBadgeWrapper = styled('div')({
  position: 'absolute',
  top: -22,
  left: 0,
});

export const StyledShiftedContentWrapper = styled('div')({
  padding: '16px 0 0 37px',
});
